module.exports = __webpack_public_path__ + "static/media/Jubel-Regular.23436650.woff2";